import * as React from 'react';
import type { SVGProps } from 'react';
const SvgError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.996 10.2a.589.589 0 0 0 .604-.596A.589.589 0 0 0 7.004 9a.589.589 0 0 0-.604.597.589.589 0 0 0 .596.603m0-2.4a.587.587 0 0 0 .429-.172A.576.576 0 0 0 7.6 7.2V4.4a.582.582 0 0 0-.171-.427.575.575 0 0 0-.425-.173.587.587 0 0 0-.429.173.576.576 0 0 0-.175.427v2.8c0 .17.057.313.171.428a.575.575 0 0 0 .425.172m.009 5.6a6.25 6.25 0 0 1-2.488-.5 6.45 6.45 0 0 1-2.042-1.375A6.453 6.453 0 0 1 1.1 9.485a6.255 6.255 0 0 1-.5-2.493 6.2 6.2 0 0 1 .5-2.484A6.453 6.453 0 0 1 4.516 1.1 6.255 6.255 0 0 1 7.008.6a6.2 6.2 0 0 1 2.484.5A6.476 6.476 0 0 1 12.9 4.512c.333.775.5 1.603.5 2.484 0 .88-.167 1.71-.5 2.487A6.45 6.45 0 0 1 9.488 12.9c-.775.333-1.603.5-2.483.5M7 12.2c1.444 0 2.672-.505 3.683-1.517C11.694 9.673 12.2 8.445 12.2 7c0-1.444-.506-2.672-1.517-3.683C9.673 2.306 8.444 1.8 7 1.8s-2.672.506-3.683 1.517C2.306 4.327 1.8 5.556 1.8 7c0 1.445.506 2.672 1.517 3.683C4.327 11.694 5.556 12.2 7 12.2"
    />
  </svg>
);
export default SvgError;
